import {NgModule} from '@angular/core';
import {NoPreloading, RouterModule, Routes} from '@angular/router';
import {HomeComponent} from 'projects/paid/src/app/routes/home/home.component';
import {
    TermsAndConditionsComponent
} from 'projects/paid/src/app/routes/terms-and-conditions/terms-and-conditions.component';
import {ConfirmSignInComponent} from 'projects/paid/src/app/components/auth/confirm-sign-in/confirm-sign-in.component';
import {GetHelpComponent} from './components/get-help/get-help.component';
import {AboutPageComponent} from './components/about-page/about-page.component';
import {UnsubscribeComponent} from './routes/unsubscribe/unsubscribe.component';
import {ForBusinessComponent} from './routes/for-business/for-business.component';
import {AiLandingComponent} from './routes/ai-landing/ai-landing.component';
import {PricingComponent} from './routes/pricing/pricing.component';
import {AfterPaymentComponent} from './components/after-payment/after-payment.component';
import {AuthGuardService} from './services/auth-guard.service';
import {PromoComponent} from './components/promo/promo.component';

const routes: Routes = [
    {
        path: '',
        component: AiLandingComponent,
        data: {
            showStart: false,
            showAiStart: true,
            showContactForDemo: false
        }
    },
    {
        path: 'tracker',
        component: HomeComponent,
        data: {
            showStart: true,
            showAiStart: false,
            showContactForDemo: false
        }
    },
    {
        path: 'login',
        component: HomeComponent,
        data: {
            showStart: true,
            showAiStart: false,
            showContactForDemo: false
        }
    },
    {
        path: 'for-business',
        component: ForBusinessComponent,
        data: {
            showStart: false,
            showAiStart: false,
            showContactForDemo: true
        }
    },

    {
        path: 'pricing',
        component: PricingComponent
    },
    {
        path: 'promo',
        component: PromoComponent,
        canActivate: [
            AuthGuardService
        ],
    },
    {
        path: 'ap',
        component: AfterPaymentComponent,
        // canActivate: [
        //     AuthGuardService
        // ],
    },
    {
        path: 'terms-and-conditions',
        component: TermsAndConditionsComponent
    },
    {
        path: 'about-us',
        component: AboutPageComponent
    },
    {
        path: 'unsubscribe',
        component: UnsubscribeComponent
    },
    {
        path: 'get-help',
        component: GetHelpComponent
    },
    {
        path: 'notice-of-privacy-practices',
        component: HomeComponent
    },
    {
        path: 'notice-of-nondiscrimination',
        component: HomeComponent
    },
    {
        path: 'login',
        component: ConfirmSignInComponent
    },
    {
        path: 'cs',
        loadChildren: () => import('./routes/select-test/select-test.module').then(m => m.SelectTestModule)
    },
    {
        path: 's',
        loadChildren: () => import('./routes/session/session.module').then(m => m.SessionModule)
    },
    {
        path: 'chat',
        loadChildren: () => import('./routes/chat/chat.module').then(m => m.ChatModule)
    },
    {
        path: 'articles',
        component: HomeComponent,
    },
    {
        path: 'articles/:id',
        component: HomeComponent,
    },
    {
        path: '404', pathMatch: 'full',
        component: HomeComponent
    },
    {
        path: '**', pathMatch: 'full',
        component: HomeComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        useHash: false,
        scrollPositionRestoration: 'top',
        onSameUrlNavigation: 'reload',
        anchorScrolling: 'enabled',
        scrollOffset: [0, 60],
        preloadingStrategy: NoPreloading
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
